<div class="aca-repo" [class.aca-repo--grid]="viewMode === 'grid'">
  <aca-page-header icon="inventory_2" [title]="'DMS.UI.A3CE7B' | translate" [subtitle]="'DMS.UI.ED3C91' | translate" />

  <!-- ── list toolbar ────────────────────────────────────────────────────────
       เอกสารทั้งหมด carries the same pair of rows: the action row (breadcrumb,
       Create, Upload — ACA's own, ordered to the front by the route stylesheet)
       and this one, holding the ordering and the column chooser. Both controls
       drive ADF's list rather than shadowing it: the select applies the same
       sorting a header click applies, and the button opens the data table's own
       column chooser.

       There is no card / list view switch: ADF 8.5's document list renders one
       way only — neither it nor the data table under it takes a display mode —
       so a switch here would have nothing to switch to.
       ─────────────────────────────────────────────────────────────────────── -->
  <div class="aca-repo__listbar">
    <div class="aca-repo__listbarleft">
      <!-- ACA's own Create / Upload toolbar is moved in here at runtime -->
      <span class="aca-repo__range" *ngIf="range() as r">
        {{ 'DMS.UI.1D31FB' | translate }}{{ r.start | number }}–{{ r.end | number }}
        <ng-container *ngIf="r.total !== null">{{ 'DMS.UI.F2DB2C' | translate }}{{ r.total | number }} {{ 'DMS.UI.4514CB' | translate }}</ng-container>
      </span>
    </div>

    <div class="aca-repo__listbarright">
      <label class="aca-repo__sort" *ngIf="sortOptions.length">
        <span class="aca-repo__sortlabel">{{ 'DMS.UI.BE35EE' | translate }}</span>
        <select class="aca-repo__select" [ngModel]="sortKey" (ngModelChange)="onSortKeyChange($event)" [attr.aria-label]="'DMS.UI.3D407E' | translate">
          <option *ngFor="let option of sortOptions" [value]="option.key">{{ option.label }}</option>
        </select>
      </label>

      <button
        type="button"
        class="aca-repo__iconbtn"
        *ngIf="sortOptions.length"
        (click)="toggleSortDirection()"
        [matTooltip]="(sortDirection === 'asc' ? 'DMS.UI.B504A6' : 'DMS.UI.1EE855') | translate"
        [attr.aria-label]="(sortDirection === 'asc' ? 'DMS.UI.CD099A' : 'DMS.UI.779FA0') | translate"
      >
        <mat-icon>{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
      </button>

      <div class="aca-repo__viewtoggle">
        <button
          type="button"
          class="aca-repo__iconbtn"
          [class.aca-repo__iconbtn--on]="viewMode === 'list'"
          (click)="setViewMode('list')"
          [matTooltip]="'DMS.UI.A738FB' | translate"
        >
          <mat-icon>view_list</mat-icon>
        </button>
        <button
          type="button"
          class="aca-repo__iconbtn"
          [class.aca-repo__iconbtn--on]="viewMode === 'grid'"
          (click)="setViewMode('grid')"
          [matTooltip]="'DMS.UI.C1D204' | translate"
        >
          <mat-icon>grid_view</mat-icon>
        </button>
      </div>

      <button type="button" class="aca-repo__columns" (click)="openColumnChooser()" [matTooltip]="'DMS.UI.AE024B' | translate">
        <mat-icon>view_column</mat-icon>
        {{ 'DMS.UI.480EF8' | translate }}
      </button>
    </div>
  </div>

  <!-- ACA's file list, unchanged: every ADF behaviour on this screen is its own -->
  <aca-files [navigationPath]="'/repository'" />
</div>
